"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _header = _interopRequireDefault(require("../header"));

var _DashboardTimezoneDisclaimer = require("./DashboardTimezoneDisclaimer");

var _LazyCharts = require("./LazyCharts");

var _interfaces = require("./interfaces");

var _AnalyticsDateFormatter = _interopRequireDefault(require("./AnalyticsDateFormatter"));

var _utils = require("./utils");

var _audienceUtils = require("./audienceUtils");

var _Loader = require("./Loader");

var _GraphTitle = require("./GraphTitle");

var _KeyInsightCard = require("./KeyInsightCard");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AudienceDashboard = /*#__PURE__*/function (_Dashboard) {
  (0, _inherits2.default)(AudienceDashboard, _Dashboard);

  var _super = _createSuper(AudienceDashboard);

  function AudienceDashboard(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AudienceDashboard);
    _this = _super.call(this, props);

    _this.setState({
      pageViewData: [],
      uniqueVisitorsData: [],
      pageViewDataV1: [],
      uniqueVisitorsDataV1: [],
      pageViews: {
        total: (0, _utils.createDefaultMetricItem)(),
        registered: (0, _utils.createDefaultMetricItem)(),
        anonymous: (0, _utils.createDefaultMetricItem)()
      },
      uniqueVisitors: {
        total: (0, _utils.createDefaultMetricItem)(),
        registered: (0, _utils.createDefaultMetricItem)(),
        anonymous: (0, _utils.createDefaultMetricItem)()
      }
    });

    return _this;
  }

  (0, _createClass2.default)(AudienceDashboard, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, _utils.trackDashboardUsage)('audience-dashboard');
                _context.next = 3;
                return Promise.all([(0, _get2.default)((0, _getPrototypeOf2.default)(AudienceDashboard.prototype), "componentDidMount", this).call(this), this.fetchKeyInsights(), this.fetchPageViewData(), this.fetchUniqueVisitorsData()]);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "fetchUniqueVisitorsData",
    value: function () {
      var _fetchUniqueVisitorsData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var response;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({
                  isUniqueVisitorsLoading: true
                });
                _context2.prev = 1;
                _context2.next = 4;
                return this.fetchViewData('unique_visitors');

              case 4:
                response = _context2.sent;
                this.setState({
                  uniqueVisitorsData: response,
                  isUniqueVisitorsLoading: false
                });
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                this.setState({
                  isUniqueVisitorsLoading: false
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));

      function fetchUniqueVisitorsData() {
        return _fetchUniqueVisitorsData.apply(this, arguments);
      }

      return fetchUniqueVisitorsData;
    }()
  }, {
    key: "fetchPageViewData",
    value: function () {
      var _fetchPageViewData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var response;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  isPageViewsLoading: true
                });
                _context3.prev = 1;
                _context3.next = 4;
                return this.fetchViewData('page_views');

              case 4:
                response = _context3.sent;
                this.setState({
                  pageViewData: response,
                  isPageViewsLoading: false
                });
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);
                this.setState({
                  isPageViewsLoading: false
                });

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 8]]);
      }));

      function fetchPageViewData() {
        return _fetchPageViewData.apply(this, arguments);
      }

      return fetchPageViewData;
    }()
  }, {
    key: "fetchViewData",
    value: function () {
      var _fetchViewData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(viewName) {
        var _this$state, startDate, endDate, filterOptions, res;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$state = this.state, startDate = _this$state.startDate, endDate = _this$state.endDate;
                filterOptions = {
                  start: _AnalyticsDateFormatter.default.formatDate(startDate),
                  end: _AnalyticsDateFormatter.default.formatDate(endDate, false)
                };
                _context4.next = 4;
                return _axios.default.post('/analyticsV2/fetchViewData', {
                  view: viewName,
                  filters: filterOptions
                });

              case 4:
                res = _context4.sent;
                return _context4.abrupt("return", res.data);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetchViewData(_x) {
        return _fetchViewData.apply(this, arguments);
      }

      return fetchViewData;
    }()
  }, {
    key: "fetchKeyInsights",
    value: function () {
      var _fetchKeyInsights = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var _this$state2, startDate, endDate, filterOptions, res, _res$data, uniqueVisitors, pageViews;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.setState({
                  isKeyInsightLoading: true
                });
                _this$state2 = this.state, startDate = _this$state2.startDate, endDate = _this$state2.endDate;
                filterOptions = {
                  start: _AnalyticsDateFormatter.default.formatDate(startDate),
                  end: _AnalyticsDateFormatter.default.formatDate(endDate, false)
                };
                _context5.prev = 3;
                _context5.next = 6;
                return _axios.default.post('/analyticsV2/audienceKeyInsights', {
                  filters: filterOptions
                });

              case 6:
                res = _context5.sent;
                _res$data = res.data, uniqueVisitors = _res$data.uniqueVisitors, pageViews = _res$data.pageViews;
                this.setState({
                  uniqueVisitors: (0, _audienceUtils.calculateMetrics)(uniqueVisitors),
                  pageViews: (0, _audienceUtils.calculateMetrics)(pageViews),
                  isKeyInsightLoading: false
                });
                _context5.next = 14;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](3);
                this.setState({
                  isKeyInsightLoading: false
                });

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[3, 11]]);
      }));

      function fetchKeyInsights() {
        return _fetchKeyInsights.apply(this, arguments);
      }

      return fetchKeyInsights;
    }()
  }, {
    key: "refetchData",
    value: function () {
      var _refetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.setState({
                  isLoading: true
                });
                _context6.prev = 1;
                _context6.next = 4;
                return Promise.all([this.fetchKeyInsights(), this.fetchPageViewData(), this.fetchUniqueVisitorsData()]);

              case 4:
                this.setState({
                  isLoading: false
                });
                _context6.next = 10;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](1);
                this.setState({
                  isLoading: false
                });

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[1, 7]]);
      }));

      function refetchData() {
        return _refetchData.apply(this, arguments);
      }

      return refetchData;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state3 = this.state,
          pageViewData = _this$state3.pageViewData,
          uniqueVisitorsData = _this$state3.uniqueVisitorsData,
          isPageViewsLoading = _this$state3.isPageViewsLoading,
          isUniqueVisitorsLoading = _this$state3.isUniqueVisitorsLoading,
          shouldChartRedraw = _this$state3.shouldChartRedraw,
          isKeyInsightLoading = _this$state3.isKeyInsightLoading,
          pageViews = _this$state3.pageViews,
          uniqueVisitors = _this$state3.uniqueVisitors;
      return (0, _preact.h)("div", {
        className: "audience-dashboard-overview dashboard-overview",
        "data-bounded-context": "Analytics",
        "data-entity": "audience-dashboard"
      }, (0, _preact.h)(_header.default, {
        title: "Audience Dashboard",
        disableCancelButton: true,
        disableSaveButton: true
      }), (0, _preact.h)("div", {
        className: "filter-container",
        ref: function ref(node) {
          _this2.wrapperRef = node;
        }
      }, this.getDateRangeFilter()), (0, _preact.h)("div", {
        className: "metric-container"
      }, (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "All unique visitors",
        total: uniqueVisitors.total.count,
        titleTooltip: "The total number of unique visitors to the community within the selected time period, identified by tracking cookie.",
        percent: uniqueVisitors.total.percentageDifference,
        isLoading: isKeyInsightLoading,
        showComparisionUnavailable: uniqueVisitors.total.previousCount === 0,
        comparisionTooltip: "The percentage difference between the total number of unique visitors to the community in the current/previous time period."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "All page views",
        total: pageViews.total.count,
        titleTooltip: "The total number of community pages loaded or reloaded in the selected time period.",
        percent: pageViews.total.percentageDifference,
        isLoading: isKeyInsightLoading,
        showComparisionUnavailable: pageViews.total.previousCount === 0,
        comparisionTooltip: "The percentage difference between the total number of community pages loaded or reloaded in the current/previous time period."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Registered unique visitors",
        total: uniqueVisitors.registered.count,
        titleTooltip: "The number of registered unique visitors to the community within the selected time period, identified by tracking cookie.",
        percent: uniqueVisitors.registered.percentageDifference,
        isLoading: isKeyInsightLoading,
        showComparisionUnavailable: uniqueVisitors.registered.previousCount === 0,
        comparisionTooltip: "The percentage difference between the number of registered unique visitors to the community in the current/previous time period."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Page views of registered visitors",
        total: pageViews.registered.count,
        titleTooltip: "The total number of community pages loaded or reloaded in the selected time period.",
        percent: pageViews.registered.percentageDifference,
        isLoading: isKeyInsightLoading,
        showComparisionUnavailable: pageViews.registered.previousCount === 0,
        comparisionTooltip: "The percentage difference between number of community pages loaded or reloaded by registered visitors in the current/previous time period."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Guest unique visitors",
        total: uniqueVisitors.anonymous.count,
        titleTooltip: "The number of guest visitors to the community within the selected time period, identified by tracking cookie.",
        percent: uniqueVisitors.anonymous.percentageDifference,
        isLoading: isKeyInsightLoading,
        showComparisionUnavailable: uniqueVisitors.anonymous.previousCount === 0,
        comparisionTooltip: "The percentage difference between the number of guest visitors to the community in the current/previous time period."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Page views of guest visitors",
        total: pageViews.anonymous.count,
        titleTooltip: "The total number of community pages loaded or reloaded in the selected time period.",
        percent: pageViews.anonymous.percentageDifference,
        isLoading: isKeyInsightLoading,
        showComparisionUnavailable: pageViews.anonymous.previousCount === 0,
        comparisionTooltip: "The percentage difference between number of community pages loaded or reloaded by guest visitors  in the current/previous time period."
      })), (0, _preact.h)("div", {
        className: "graph-wrapper"
      }, (0, _preact.h)("div", {
        className: "graph-container",
        ref: function ref(element) {
          _this2.barChart = element;
        }
      }, (0, _preact.h)("div", {
        className: "graph-row"
      }, (0, _preact.h)(_GraphTitle.GraphTitle, {
        title: "Unique visitors",
        tooltipMessage: "The total number of unique visitors within the selected time period, identified by tracking cookie."
      }), isUniqueVisitorsLoading ? (0, _preact.h)(_Loader.Loader, null) : (0, _preact.h)(_LazyCharts.Bar, {
        redraw: shouldChartRedraw,
        data: (0, _audienceUtils.getBarChartDataDataSet)(uniqueVisitorsData),
        options: (0, _utils.getBarChartOptions)(false)
      })), (0, _preact.h)("div", {
        className: "graph-row"
      }, (0, _preact.h)(_GraphTitle.GraphTitle, {
        title: "Page views",
        tooltipMessage: "The total number of community pages loaded or reloaded in the selected time period."
      }), isPageViewsLoading ? (0, _preact.h)(_Loader.Loader, null) : (0, _preact.h)(_LazyCharts.Bar, {
        redraw: shouldChartRedraw,
        data: (0, _audienceUtils.getBarChartDataDataSet)(pageViewData),
        options: (0, _utils.getBarChartOptions)(false)
      })))), (0, _preact.h)(_DashboardTimezoneDisclaimer.DashboardTimezoneDisclaimer, null));
    }
  }]);
  return AudienceDashboard;
}(_interfaces.Dashboard);

var _default = AudienceDashboard;
exports.default = _default;